// ---------------------------------------------------------------------------
// AuthBackdrop — signature dark glass + gradient mesh + faint grid + two
// blurred accent orbs. Shared by every unauthenticated auth surface (login,
// forgot password, reset password, MFA setup, signup) so the funnel reads
// as one experience. Pair with a card sitting at z-10:
//
//   <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0A0E17]">
//     <AuthBackdrop />
//     <div className="relative z-10 ...">...</div>
//   </div>
// ---------------------------------------------------------------------------

export function AuthBackdrop() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse at 20% 50%, rgba(124, 58, 237, 0.15) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 20%, rgba(37, 99, 235, 0.12) 0%, transparent 50%),
            radial-gradient(ellipse at 60% 80%, rgba(13, 148, 136, 0.08) 0%, transparent 50%),
            linear-gradient(180deg, #060912 0%, #0A0E17 50%, #0D1220 100%)
          `,
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-20 -top-32 h-[400px] w-[400px] rounded-full blur-[40px]"
        style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.08) 0%, transparent 70%)' }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-24 -left-16 h-[350px] w-[350px] rounded-full blur-[40px]"
        style={{ background: 'radial-gradient(circle, rgba(37,99,235,0.06) 0%, transparent 70%)' }}
      />
    </>
  );
}

export default AuthBackdrop;
